var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocplaceVector4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V5L13 0ZM4 4H9V6H4V4ZM14 14H4V12H14V14ZM14 10H4V8H14V10ZM12 6V2L16 6H12Z",
    fill: "#006AC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocplaceVector4);
export default __webpack_public_path__ + "static/media/Docplace Vector (4).a94e1aa04a29d5631cbf6a58d2abb433.svg";
export { ForwardRef as ReactComponent };